import { createFileRoute, lazyRouteComponent } from '@tanstack/react-router';

import { renderInstructorPage } from './-route-wrappers';

const EditAnswer = lazyRouteComponent(() => import('@/_instructor/on-demand-tutoring/edit-answers'));

export const Route = createFileRoute('/_instructor/on-demand-tutoring/edit-answer')({
  component: () => renderInstructorPage(EditAnswer),
});
